import { cn } from '@/utils/cn';

interface SearchResultRowProps {
  name: string;
  email: string;
  isHighlighted: boolean;
  onClick: () => void;
}

export function SearchResultRow({
  name,
  email,
  isHighlighted,
  onClick,
}: SearchResultRowProps) {
  return (
    <div
      role="option"
      aria-selected={isHighlighted}
      onClick={onClick}
      className={cn(
        'px-s py-xs cursor-pointer',
        isHighlighted
          ? 'bg-[var(--background-card)]'
          : 'hover:bg-[var(--background-card-elevated)]'
      )}
    >
      <p className="text-body-s text-[var(--text-content-title)]">{name}</p>
      <p className="text-body-xs text-[var(--text-content-sub-title)]">
        {email}
      </p>
    </div>
  );
}
